import React from 'react'
import s from './AcademicPerformance.module.scss'
import { ReactComponent as CapIcon } from 'assets/icons/cap.svg'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow-diagram.svg'
import useAcademicPerformance from './hooks/useAcademicPerformance'
import LoaderImg from 'shared/components/LoaderImg/LoaderImg'

const AcademicPerformance = ({ data, isLoading = false }) => {
	const { stats, hasAnyStat } = useAcademicPerformance({ data })

	return (
		<section className={s.card}>
			<div className={s.head}>
				<span className={s.head__icon}>
					<CapIcon />
				</span>
				<h3 className={s.head__title}>Performances</h3>
				{(isLoading || hasAnyStat) && (
					<span className={s.badge}>
						<span className={s.badge__icon}>
							<ArrowIcon />
						</span>
						<span className={s.badge__text}>Improving</span>
					</span>
				)}
			</div>

			{isLoading ? (
				<div className={s.stats}>
					{stats.map(stat => (
						<div key={stat.label} className={s.stat}>
							<span className={s.stat__label}>{stat.label}</span>
							<span className={`${s.loader} ${s.loaderValue}`}>
								<LoaderImg />
							</span>
						</div>
					))}
				</div>
			) : hasAnyStat ? (
				<div className={s.stats}>
					{stats.map(stat => (
						<div key={stat.label} className={s.stat}>
							<span className={s.stat__label}>{stat.label}</span>
							<span className={s.stat__value}>{stat.value || '-'}</span>
						</div>
					))}
				</div>
			) : (
				<p className={s.empty}>Student hasn't added performance data yet.</p>
			)}
		</section>
	)
}

export default AcademicPerformance
